import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../theme/colors';

export default makeStyles((theme) => ({
  drawerContentContainer: {
    width       : theme.spacing(46),
    paddingLeft : theme.spacing(2),
    paddingTop  : theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  closeButtonContainer:{
    height        : theme.spacing(6),
    display       : 'flex',
    justifyContent: 'flex-end',
    alignItems    : 'center',
    padding       : theme.spacing(1)
  },
  drawerCloseButton: {
    color : colors.SESAMSEC_SYS_LIGHT_ON_SURFACE_VARIANT,
    cursor: 'pointer'
  },
  drawerTitle: {
    fontWeight  : 'bold',
    fontSize    : theme.spacing(2.75),
    paddingRight: theme.spacing(2),
    lineHeight  : '26.4px'
  },
  eventTime: {
    fontSize: theme.spacing(1.75)
  },
  chipSkeletonContainer: {
    marginTop   : theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  chipContainer: {
    display        : 'inline-flex',
    alignItems     : 'center',
    padding        : '4px 8px',
    backgroundColor: '#EAEBEB',
    borderRadius   : theme.spacing(1),
    marginTop      : theme.spacing(3),
    marginBottom   : theme.spacing(3)
  },
  chipText: {
    marginLeft: theme.spacing(0.5),
    fontSize  : theme.spacing(1.75)
  },
  helperContainer: {
    marginTop     : theme.spacing(3), 
    marginBottom  : theme.spacing(1), 
    textDecoration: 'underline', 
    cursor        : 'pointer'
  },
  card: {
    border      : `1px solid ${colors.SESAMSEC_SYS_LIGHT_OUTLINE_SILENT}`,
    borderRadius: theme.spacing(0.5),
    marginBottom: theme.spacing(2)
  },
  cardTitle: {
    fontSize  : theme.spacing(2),
    fontWeight: 'bold',
    lineHeight: 0,
  },
  fieldContainer: {
    display      : 'flex',
    flexDirection: 'column',
  },
  fieldRow: {
    display     : 'flex',
    marginBottom: theme.spacing(2),
    alignItems  : 'start'
  },
  lastFieldRow: {
    display: 'flex',
  },
  fieldKey: {
    width   : theme.spacing(17.5),
    minWidth: theme.spacing(17.5),
    fontSize: theme.spacing(1.75),
    color   : colors.SESAMSEC_SYS_LIGHT_ON_SURFACE_VARIANT
  },
  fieldValue: {
    alignItems    : 'center',
    color         : colors.SESAMSEC_SYS_LIGHT_ON_SURFACE_VARIANT,
    display       : 'flex',
    flex          : '1',
    justifyContent: 'space-between',
    maxWidth      : theme.spacing(24),
    wordBreak     : 'break-word'
  },
  emphasizeFieldValue: {
    alignItems    : 'center',
    color         : colors.SESAMSEC_SYS_LIGHT_ON_SURFACE,
    display       : 'flex',
    flex          : '1',
    justifyContent: 'space-between',
    margin        : '0px 0px',
    wordBreak     : 'break-word'
  },
  presentEntity: {
    cursor        : 'pointer',
    textDecoration: 'underline',
  },
  valueContainer: {
    display   : 'flex',
    alignItems: 'center'
  },
  baseStatus: {
    width       : theme.spacing(1.5), 
    height      : theme.spacing(1.5),
    borderRadius: '50%',
    display     : 'inline-block',
    marginRight : theme.spacing(0.75)
  },
  onlineStatus: {
    backgroundColor: colors.SESAMSEC_SYS_LIGHT_SECONDARY, 
  },
  offlineStatus: {
    backgroundColor: colors.SESAMSEC_SYS_LIGHT_ON_SURFACE_VARIANT, 
  },
  noteDivider: {
    borderBottom: `1px dashed ${colors.SESAMSEC_SYS_LIGHT_OUTLINE_VARIANT}`,
  },
  noteContainer: {
    marginTop: theme.spacing(2)
  },
  noteText: {
    fontSize: theme.spacing(1.75),
    color   : colors.SESAMSEC_SYS_LIGHT_ON_SURFACE_VARIANT
  },
  infoIcon: {
    color     : colors.SESAMSEC_SYS_LIGHT_ON_SURFACE_VARIANT,
    fontSize  : theme.spacing(2.25),
    marginLeft: theme.spacing(0.5)
  },
  deleteEntityTooltip: {
    fontSize: theme.spacing(1.75)
  }
}))